// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"108":"3f9431d0d5ccd89e","161":"4f24a3cb4732edcd","483":"5cbdbbca7069a539","659":"02fc84722dcfaf63","688":"de34f26ab14cd386","745":"fb4fa60528cb23b3","954":"e191205e82a872e7"}[chunkId] + ".js";
};